module.exports = __webpack_public_path__ + "static/img/5.cc8881e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/5.jpg
// module id = 6nQN
// module chunks = 0